import { render, staticRenderFns } from "./PurchaseInputManager.vue?vue&type=template&id=45bb8873&"
import script from "./PurchaseInputManager.vue?vue&type=script&lang=js&"
export * from "./PurchaseInputManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseInputManager.vue"
export default component.exports